/**
 * @module lib/commercial/keytar/common/teaser
 */
import { paywallTemplate, templateParams } from "lib/commercial/keytar/common/takeover";
import { defaultWall, removeNode } from "../common/preview";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import isNumber from "lodash/isNumber";
import isNil from "lodash/isNil";
import { qs } from "utils/utils";
import logger from "utils/logger";
import CONSTS from "lib/consts";

const debugTag = "[TEASER WALL]";

/**
 * @method setUpTeaserView
 * @description creates a teaser wall that will be either the default paywall or the result of darwin function
 * @param {String} wallName - wall name type
 * @param {Function} darwinTemplate - darwin function or custom object (if regwall)
 * @param {Number} paragraphs - paragraphs
 * @param {String} contentType - contentType
 */
export function setUpTeaserView(wallName, darwinTemplate = () => null, paragraphs, contentType) {
  const dwIsFunction = isFunction(darwinTemplate);
  const dwRenderResult = dwIsFunction ? darwinTemplate() : null;

  const articleBody = qs(".js-c-article-body");
  articleBody && articleBody.classList.add("c-article-body__teaser-enabled");

  const paywallClasses = ["c-keytar-container__main--subscriber"];
  const teaserClasses = wallName !== "registeredPaywall" ? paywallClasses : [];

  // May be passed via Darwin test
  const teaserWallConfigs = {
    isTeaserView: true,
    paragraphs
  };
  const additionalElemToRemove = {
    metaActions: qs(".c-article-meta__actions"),
    comments: qs(".c-comments")
  };

  let html = null;

  if (dwIsFunction && !isNil(dwRenderResult)) {
    // Darwin takeover--use CEM defined function to display wall
    logger.info(`${debugTag} Registered template - teaser, Darwin function`);
    html = dwRenderResult;

  } else if (dwIsFunction && isNil(dwRenderResult)) {
    // Darwin takeover--CEM didn't supply a function to replace the wall so show the default one
    logger.info(`${debugTag} Registered template - teaser, Darwin, default wall`);
    const temp = wallName === "hardPaywall"
      ? templateParams.hardPaywall
      : templateParams.meteredPaywall;
    html = paywallTemplate(temp);

  } else if (wallName === "registeredPaywall") {
    // Darwin takeover--CEM may define an object that contains the url and height for iFrame
    const { url, height } = isObject(darwinTemplate) ? darwinTemplate : {};
    html = `
      <iframe
        id="teaser-keytar-iframe"
        name="keytar-iframe"
        class="js-keytar-iframe c-keytar-content"
        title="Paywall"
        scrolling="yes"
        width="100%"
        height="${isNumber(height) ? height : 820}"
        frameborder="0"
        allowtransparency="true"
        src="${url ? url : CONSTS.URLS.REGISTER.REGWALL}"
      >
      </iframe>
    `;
  }

  let error = null;

  if (!defaultWall(html, contentType, wallName, teaserWallConfigs)) {
    error = "the article body";
  }

  const teaserBody = qs(".js-c-teaser-body");
  teaserClasses.forEach(klass => teaserBody && teaserBody.classList.add(klass));

  if (error) {
    logger.error(debugTag, `Aborting - Registered Template cannot find ${error}`);
    return;
  }

  // Don't show comments, bookmarks, and audio (if they exist).
  Object.values(additionalElemToRemove).forEach(removeNode);
}
